<template>
  <div class="authenticated">
    <banner></banner>
    <navigation></navigation>
    <div class="container">
      <div class="application-content">
        <alert v-if="isError" type="danger"></alert>
        <alert v-if="isMessage" type="primary"></alert>
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Alert from '@/components/Alert'
  import Nav from '@/components/Nav'
  import Banner from '@/components/Banner'

  export default {
    name: 'Application',
    data () {
      return {}
    },
    computed: {
      ...mapGetters(['isError', 'isMessage'])
    },
    components: {
      alert: Alert,
      navigation: Nav,
      banner: Banner
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/application/Application.vue